import { c as _c } from "react/compiler-runtime";
import type { Entry, UnresolvedLink } from "contentful";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { isEntry } from "@/lib/contentful/guards";
import type { TypeMaterialSkeleton } from "@/types/contentful/generated";
import { SpecsTable } from "./SpecsTable";
type MaterialEntry = Entry<TypeMaterialSkeleton, undefined, string>;
type MaterialBlock = MaterialEntry | UnresolvedLink<"Entry">;
interface Props {
  header?: string;
  materials: MaterialBlock[];
}
export default function Specs(t0) {
  const $ = _c(20);
  const {
    header,
    materials
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== header || $[1] !== materials) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const resolvedMaterials = materials.filter(_temp);
      if (resolvedMaterials.length === 0) {
        t6 = null;
        break bb0;
      }
      const defaultTab = resolvedMaterials[0].sys.id;
      t4 = "p-6 w-full max-w-site-content mx-auto";
      if ($[9] !== header) {
        t5 = header && <h2 className="heading-lg text-left mb-6">{header}</h2>;
        $[9] = header;
        $[10] = t5;
      } else {
        t5 = $[10];
      }
      T0 = Tabs;
      t1 = defaultTab;
      t2 = <TabsList>{resolvedMaterials.map(_temp2)}</TabsList>;
      t3 = resolvedMaterials.map(_temp3);
    }
    $[0] = header;
    $[1] = materials;
    $[2] = T0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    T0 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[11] !== T0 || $[12] !== t1 || $[13] !== t2 || $[14] !== t3) {
    t7 = <T0 defaultValue={t1}>{t2}{t3}</T0>;
    $[11] = T0;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t7) {
    t8 = <div className={t4}>{t5}{t7}</div>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
function _temp3(material_0) {
  return <TabsContent key={material_0.sys.id} value={material_0.sys.id}><SpecsTable material={material_0} /></TabsContent>;
}
function _temp2(material) {
  return <TabsTrigger key={material.sys.id} value={material.sys.id}>{material.fields.publicNameOverride}</TabsTrigger>;
}
function _temp(m) {
  return isEntry(m);
}